import * as React from 'react';
import { Utilities, PlatformType } from '@microsoft/office-js-helpers';
import Config from '../Config';

interface PinTaskpaneHintState {
    showHint: boolean;
}

const MAX_TIMES_SHOWN: number = 4;

export default class PinTaskpaneHint extends React.Component<undefined, PinTaskpaneHintState> {

    private _hintTarget: HTMLDivElement;


    static doesOutlookSupportPinnableTaskpane(): boolean {
        // At the time of this writing, pinnable task pane was only supported on Outlook 2016 Desktop
        if (Office.context.requirements.isSetSupported("Mailbox", 1.5) && Office.context.diagnostics.platform == Office.PlatformType.PC) {
            return true;
        }
        else {
            return false;
        }
    }

    constructor(props: undefined) {
        super(props);

        var showHint: boolean;

        if (PinTaskpaneHint.doesOutlookSupportPinnableTaskpane()) {
            if (Config.getPinTaskpaneHintClosed()) {
                showHint = false;
            }
            else if (Config.getPinTaskpaneHintDisplayCount() >= MAX_TIMES_SHOWN) {

                // show it occasionally
                if (Config.getPinTaskpaneHintDisplayCount() % MAX_TIMES_SHOWN == 0)
                    showHint = true;
                else
                    showHint = false;
            }
            else {
                showHint = true;
            }
        }
        else {
            // pinning not supported
            showHint = false;
        }

        this.state = {
            showHint: showHint
        };
    }

    componentDidMount() {
        this._incrementDisplayCount();
    }

    render() {
        if (this.state.showHint == false) {
            return null;
        }
        else {
            return <div className="PinTaskpaneHint">
                <p>
                    <strong>Tip:</strong>&nbsp;Click the pin icon to keep the<br />
                    Protected Trust taskpane open.
                </p>
                <p><a href="#" onClick={(e) => { this._closeClicked(e) }}>Ok, got it.</a></p>
            </div>;
        }
    }

    private _closeClicked(e: React.MouseEvent<HTMLElement>) {
        e.preventDefault();
        this.setState({
            showHint: false
        });

        Config.setPinTaskpaneHintClosed(true);
    }

    private _incrementDisplayCount() {
        var count: number = Config.getPinTaskpaneHintDisplayCount();
        count += 1;
        Config.setPinTaskpaneHintDisplayCount(count);
    }

}


// WEBPACK FOOTER //
// ./src/D:/a/1/s/src/components/PinTaskpaneHint.tsx